import { NSARouterMakerResult } from "namirasoft-account-react";
import { BaseMetaColumn, IStorageLocal } from "namirasoft-core";
import { LoadBalancerTargetRow, NamirasoftInferenceMetaDatabase } from "namirasoft-inference";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, EnumFormatter, IDFormatter, IntegerFormatter, NSColumn, NSTable, NSTitle, TableColumnInfo } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

interface LoadBalancerTargetsViewProps extends NSARouterMakerResult, InferenceRouterProps
{
	load_balancer_id: string;
	rows: LoadBalancerTargetRow[];
}

interface LoadBalancerTargetsViewState
{
	columns: TableColumnInfo[] | null;
}

export default class LoadBalancerTargetsView extends Component<LoadBalancerTargetsViewProps, LoadBalancerTargetsViewState>
{
	override state: LoadBalancerTargetsViewState = { columns: null };

	private Table_Ref = createRef<NSTable<LoadBalancerTargetRow>>();

	override componentDidMount(): void { this.setState({ columns: this.buildColumns() }); }

	override componentDidUpdate(prev: LoadBalancerTargetsViewProps): void
	{
		if (prev.load_balancer_id !== this.props.load_balancer_id || prev.rows !== this.props.rows)
			this.Table_Ref.current?.reload(null, null);
	}

	private buildColumns(): TableColumnInfo[]
	{
		let inference = new NamirasoftInferenceMetaDatabase(this.props.account.token_manager, console.error);
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
		let table = inference.tables.load_balancer;
		let inferencer_type_col = new BaseMetaColumn(table, "inferencer_type", "Type", "Enum", true);
		let inferencer_id_col = new BaseMetaColumn(table, "inferencer_id", "Target", inference.tables.model.columns.id.type, true);
		let weight_col = new BaseMetaColumn(table, "weight", "Weight", "Integer", true);
		return [
			BaseColumnFormatter.getColumn(inferencer_type_col, new EnumFormatter()),
			BaseColumnFormatter.getColumn(inferencer_id_col, new IDFormatter(namirasoft, new IStorageLocal())),
			BaseColumnFormatter.getColumn(weight_col, new IntegerFormatter()),
		];
	}

	private getRows = async (): Promise<{ rows: LoadBalancerTargetRow[], count: number }> =>
	{
		let rows = this.props.rows ?? [];
		return { rows, count: rows.length };
	};

	override render()
	{
		let { columns } = this.state;
		return (
			<NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
				<NSTitle title="Targets" />
				<div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", flexGrow: 1 }}>
					<NSTable<LoadBalancerTargetRow>
						ref={this.Table_Ref}
						name="load-balancer-targets"
						checkbox={false}
						columns={columns ?? this.buildColumns()}
						getRows={this.getRows}
						getRowKey={(row) => row.value.id}
						ui={{ pagination: false, button_panel: false }}
					/>
				</div>
			</NSColumn>
		);
	}
}